// priceRules.js

const priceRules = [
    {
      id: "hell",
      formula: "1",
      porice1: ["ref_sideLiteGlass", "doorData.sideLite.sideLiteOptionsS_label"],
      porice2: ["Gentek", "doorData.frameData.frameColor"],
      unitPrice: 7,
      multiplicator: {
        condition: "true",
        value: 2
      }
    },
    {
      id: 'ref_rangeWindowPricesWhite',
      rows: [
  { min: 0,      max: 6.001,    'Picture': 66.50,           'Fixed Casement': 73.50,           'Double Slider Tilt': 105.70,          'Double Hung Tilt': 109.20,          'Casement': 112,             'Awning': 114.80,          'End-Vent': 158.90,          'Single Hung Tilt': 99.40,           'Single Slider Tilt': 94.50,           'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 6.001,  max: 7.001,    'Picture': 66.50,           'Fixed Casement': 73.50,           'Double Slider Tilt': 116.20,          'Double Hung Tilt': 121.10,          'Casement': 128.10,          'Awning': 130.90,          'End-Vent': 158.90,          'Single Hung Tilt': 112.00,          'Single Slider Tilt': 109.20,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 7.001,  max: 9.001,    'Picture': '9.80*square',   'Fixed Casement': '10.85*square',  'Double Slider Tilt': 116.20,          'Double Hung Tilt': 121.10,          'Casement': 128.10,          'Awning': 130.90,          'End-Vent': 158.90,          'Single Hung Tilt': 112.00,          'Single Slider Tilt': 109.20,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 9.001,  max: 12.001,   'Picture': '9.80*square',   'Fixed Casement': '10.85*square',  'Double Slider Tilt': 130.90,          'Double Hung Tilt': 139.30,          'Casement': 144.90,          'Awning': 150.50,          'End-Vent': 158.90,          'Single Hung Tilt': 129.50,          'Single Slider Tilt': 124.60,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 12.001, max: 14.001,   'Picture': '9.80*square',   'Fixed Casement': '10.85*square',  'Double Slider Tilt': '10.92*square',  'Double Hung Tilt': '11.62*square',  'Casement': '12.01*square',  'Awning': '12.54*square',  'End-Vent': 158.90,          'Single Hung Tilt': '10.79*square',  'Single Slider Tilt': '10.38*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 14.001, max: 9999.001, 'Picture': '9.80*square',   'Fixed Casement': '10.85*square',  'Double Slider Tilt': '10.92*square',  'Double Hung Tilt': '11.62*square',  'Casement': '12.01*square',  'Awning': '12.54*square',  'End-Vent': '11.38*square',  'Single Hung Tilt': '10.79*square',  'Single Slider Tilt': '10.38*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
     ]
    },
    {
      id: 'ref_rangeWindowPricesColor',
      rows: [
  { min: 0,      max: 6.001,    'Picture': 82.65,            'Fixed Casement': 91.35,           'Double Slider Tilt': 131.37,          'Double Hung Tilt': 135.72,          'Casement': 139.20,          'Awning': 142.68,          'End-Vent': 197.49,          'Single Hung Tilt': 123.54,          'Single Slider Tilt': 117.45,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 6.001,  max: 7.001,    'Picture': 82.65,            'Fixed Casement': 91.35,           'Double Slider Tilt': 144.42,          'Double Hung Tilt': 150.51,          'Casement': 159.21,          'Awning': 162.69,          'End-Vent': 197.49,          'Single Hung Tilt': 139.20,          'Single Slider Tilt': 135.72,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 7.001,  max: 9.001,    'Picture': '12.18*square',   'Fixed Casement': '13.49*square',  'Double Slider Tilt': 144.42,          'Double Hung Tilt': 150.51,          'Casement': 159.21,          'Awning': 162.69,          'End-Vent': 197.49,          'Single Hung Tilt': 139.20,          'Single Slider Tilt': 135.72,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 9.001,  max: 12.001,   'Picture': '12.18*square',   'Fixed Casement': '13.49*square',  'Double Slider Tilt': 162.69,          'Double Hung Tilt': 173.13,          'Casement': 180.09,          'Awning': 187.05,          'End-Vent': 197.49,          'Single Hung Tilt': 160.95,          'Single Slider Tilt': 154.86,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 12.001, max: 14.001,   'Picture': '12.18*square',   'Fixed Casement': '13.49*square',  'Double Slider Tilt': '13.57*square',  'Double Hung Tilt': '14.44*square',  'Casement': '14.92*square',  'Awning': '15.58*square',  'End-Vent': 197.49,          'Single Hung Tilt': '13.42*square',  'Single Slider Tilt': '12.90*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 14.001, max: 9999.001, 'Picture': '12.18*square',   'Fixed Casement': '13.49*square',  'Double Slider Tilt': '13.57*square',  'Double Hung Tilt': '14.44*square',  'Casement': '14.92*square',  'Awning': '15.58*square',  'End-Vent': '11.38*square',  'Single Hung Tilt': '13.42*square',  'Single Slider Tilt': '12.90*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
     ]
    },
    {
      id: 'ref_rangeWindowPricesDoubleColor',
      rows: [
  { min: 0,      max: 6.001,    'Picture': 106.40,           'Fixed Casement': 117.60,          'Double Slider Tilt': 169.12,          'Double Hung Tilt': 174.72,          'Casement': 179.20,          'Awning': 183.68,          'End-Vent': 254.24,          'Single Hung Tilt': 159.04,          'Single Slider Tilt': 151.20,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 6.001,  max: 7.001,    'Picture': 106.40,           'Fixed Casement': 117.60,          'Double Slider Tilt': 185.92,          'Double Hung Tilt': 193.76,          'Casement': 204.96,          'Awning': 209.44,          'End-Vent': 254.24,          'Single Hung Tilt': 179.20,          'Single Slider Tilt': 174.72,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 7.001,  max: 9.001,    'Picture': '15.68*square',   'Fixed Casement': '17.36*square',  'Double Slider Tilt': 185.92,          'Double Hung Tilt': 193.76,          'Casement': 204.96,          'Awning': 209.44,          'End-Vent': 254.24,          'Single Hung Tilt': 179.20,          'Single Slider Tilt': 174.72,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 9.001,  max: 12.001,   'Picture': '15.68*square',   'Fixed Casement': '17.36*square',  'Double Slider Tilt': 209.44,          'Double Hung Tilt': 222.88,          'Casement': 231.84,          'Awning': 240.80,          'End-Vent': 254.24,          'Single Hung Tilt': 207.20,          'Single Slider Tilt': 199.36,          'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 12.001, max: 14.001,   'Picture': '15.68*square',   'Fixed Casement': '17.36*square',  'Double Slider Tilt': '17.47*square',  'Double Hung Tilt': '18.59*square',  'Casement': '19.21*square',  'Awning': '20.06*square',  'End-Vent': 254.24,          'Single Hung Tilt': '17.27*square',  'Single Slider Tilt': '16.61*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 14.001, max: 9999.001, 'Picture': '15.68*square',   'Fixed Casement': '17.36*square',  'Double Slider Tilt': '17.47*square',  'Double Hung Tilt': '18.59*square',  'Casement': '19.21*square',  'Awning': '20.06*square',  'End-Vent': '11.38*square',  'Single Hung Tilt': '17.27*square',  'Single Slider Tilt': '16.61*square',  'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
     ]
    },
  
    
    {
      id: 'ref_rangeWindowPrices',
      rows: [
  { min: 0, max: 6.001,         Picture: 750,  'Fixed Casement':  778, 'Double Slider Tilt':  856, 'Double Hung Tilt':  872, 'Casement':  954, 'Awning':  954, 'End-Vent': 1198, 'Single Slider Tilt':  836, 'Single Hung Tilt':  854, 'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 6.001,  max: 7.001,    Picture: 864,  'Fixed Casement':  884, 'Double Slider Tilt':  904, 'Double Hung Tilt':  936, 'Casement': 1054, 'Awning': 1054, 'End-Vent': 1198, 'Single Slider Tilt':  884, 'Single Hung Tilt':  916, 'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 7.001,  max: 8.001,    Picture: 894,  'Fixed Casement':  920, 'Double Slider Tilt':  954, 'Double Hung Tilt':  964, 'Casement': 1114, 'Awning': 1114, 'End-Vent': 1198, 'Single Slider Tilt':  934, 'Single Hung Tilt':  942, 'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 8.001,  max: 9.001,    Picture: 946,  'Fixed Casement':  992, 'Double Slider Tilt': 1002, 'Double Hung Tilt': 1034, 'Casement': 1160, 'Awning': 1160, 'End-Vent': 1198, 'Single Slider Tilt':  982, 'Single Hung Tilt': 1014, 'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 9.001,  max: 10.001,   Picture: 940,  'Fixed Casement': 1066, 'Double Slider Tilt': 1052, 'Double Hung Tilt': 1064, 'Casement': 1250, 'Awning': 1250, 'End-Vent': 1198, 'Single Slider Tilt': 1032, 'Single Hung Tilt': 1044, 'Tilt and Turn': 2346, 'Fixed Tilt&Turn': 2244, 'Turn Only': 2040},
  { min: 10.001, max: 11.001,   Picture: 1070, 'Fixed Casement': 1144, 'Double Slider Tilt': 1130, 'Double Hung Tilt': 1138, 'Casement': 1300, 'Awning': 1300, 'End-Vent': 1218, 'Single Slider Tilt': 1108, 'Single Hung Tilt': 1118, 'Tilt and Turn': 2376, 'Fixed Tilt&Turn': 2304, 'Turn Only': 2124},
  { min: 11.001, max: 12.001,   Picture: 1160, 'Fixed Casement': 1190, 'Double Slider Tilt': 1166, 'Double Hung Tilt': 1184, 'Casement': 1364, 'Awning': 1364, 'End-Vent': 1254, 'Single Slider Tilt': 1146, 'Single Hung Tilt': 1166, 'Tilt and Turn': 2460, 'Fixed Tilt&Turn': 2450, 'Turn Only': 2208},
	{ min: 12.001, max: 13.001,   Picture: 1210, 'Fixed Casement': 1282, 'Double Slider Tilt': 1232, 'Double Hung Tilt': 1246, 'Casement': 1454, 'Awning': 1454, 'End-Vent': 1324, 'Single Slider Tilt': 1212, 'Single Hung Tilt': 1224, 'Tilt and Turn': 2544, 'Fixed Tilt&Turn': 2592, 'Turn Only': 2292},
	{ min: 13.001, max: 14.001,   Picture: 1346, 'Fixed Casement': 1396, 'Double Slider Tilt': 1334, 'Double Hung Tilt': 1348, 'Casement': 1562, 'Awning': 1562, 'End-Vent': 1422, 'Single Slider Tilt': 1312, 'Single Hung Tilt': 1326, 'Tilt and Turn': 2730, 'Fixed Tilt&Turn': 2808, 'Turn Only': 2466},
	{ min: 14.001, max: 9999.001, Picture: 100,  'Fixed Casement': 102 , 'Double Slider Tilt':   96, 'Double Hung Tilt':   96, 'Casement':  110, 'Awning':  110, 'End-Vent':   96, 'Single Slider Tilt':   94, 'Single Hung Tilt':   94, 'Tilt and Turn':  230, 'Fixed Tilt&Turn':  204, 'Turn Only':  180},
     ] 
    },
    {
      id: 'ref_rangeWindowPrices2',
      rows: [
  { min: 0, max: 6.001,         Picture: 870,  'Fixed Casement':  898, 'Double Slider Tilt':  976, 'Double Hung Tilt':  992, 'Casement': 1074, 'Awning': 1074, 'End-Vent': 1318, 'Single Slider Tilt':  956, 'Single Hung Tilt':  974, 'Tilt and Turn': 2514, 'Fixed Tilt&Turn': 2412, 'Turn Only': 2208},
  { min: 6.001,  max: 7.001,    Picture: 1004, 'Fixed Casement': 1024, 'Double Slider Tilt': 1044, 'Double Hung Tilt': 1076, 'Casement': 1194, 'Awning': 1194, 'End-Vent': 1338, 'Single Slider Tilt': 1024, 'Single Hung Tilt': 1056, 'Tilt and Turn': 2542, 'Fixed Tilt&Turn': 2440, 'Turn Only': 2236},
  { min: 7.001,  max: 8.001,    Picture: 1054, 'Fixed Casement': 1080, 'Double Slider Tilt': 1114, 'Double Hung Tilt': 1124, 'Casement': 1274, 'Awning': 1274, 'End-Vent': 1358, 'Single Slider Tilt': 1094, 'Single Hung Tilt': 1102, 'Tilt and Turn': 2570, 'Fixed Tilt&Turn': 2468, 'Turn Only': 2264},
  { min: 8.001,  max: 9.001,    Picture: 1126, 'Fixed Casement': 1172, 'Double Slider Tilt': 1182, 'Double Hung Tilt': 1214, 'Casement': 1340, 'Awning': 1340, 'End-Vent': 1378, 'Single Slider Tilt': 1162, 'Single Hung Tilt': 1194, 'Tilt and Turn': 2598, 'Fixed Tilt&Turn': 2496, 'Turn Only': 2292},
  { min: 9.001,  max: 10.001,   Picture: 1140, 'Fixed Casement': 1266, 'Double Slider Tilt': 1252, 'Double Hung Tilt': 1264, 'Casement': 1450, 'Awning': 1450, 'End-Vent': 1398, 'Single Slider Tilt': 1232, 'Single Hung Tilt': 1244, 'Tilt and Turn': 2626, 'Fixed Tilt&Turn': 2524, 'Turn Only': 2320},
  { min: 10.001, max: 11.001,   Picture: 1290, 'Fixed Casement': 1364, 'Double Slider Tilt': 1350, 'Double Hung Tilt': 1358, 'Casement': 1520, 'Awning': 1520, 'End-Vent': 1438, 'Single Slider Tilt': 1328, 'Single Hung Tilt': 1338, 'Tilt and Turn': 2684, 'Fixed Tilt&Turn': 2612, 'Turn Only': 2432},
  { min: 11.001, max: 12.001,   Picture: 1400, 'Fixed Casement': 1430, 'Double Slider Tilt': 1406, 'Double Hung Tilt': 1424, 'Casement': 1604, 'Awning': 1604, 'End-Vent': 1494, 'Single Slider Tilt': 1386, 'Single Hung Tilt': 1406, 'Tilt and Turn': 2796, 'Fixed Tilt&Turn': 2786, 'Turn Only': 2544},
	{ min: 12.001, max: 13.001,   Picture: 1470, 'Fixed Casement': 1542, 'Double Slider Tilt': 1492, 'Double Hung Tilt': 1506, 'Casement': 1704, 'Awning': 1714, 'End-Vent': 1584, 'Single Slider Tilt': 1472, 'Single Hung Tilt': 1484, 'Tilt and Turn': 2908, 'Fixed Tilt&Turn': 2956, 'Turn Only': 2656},
	{ min: 13.001, max: 14.001,   Picture: 1626, 'Fixed Casement': 1676, 'Double Slider Tilt': 1614, 'Double Hung Tilt': 1628, 'Casement': 1842, 'Awning': 1842, 'End-Vent': 1702, 'Single Slider Tilt': 1592, 'Single Hung Tilt': 1606, 'Tilt and Turn': 3122, 'Fixed Tilt&Turn': 3200, 'Turn Only': 2858},
	{ min: 14.001, max: 9999.001, Picture: 100,  'Fixed Casement':  122, 'Double Slider Tilt':  116, 'Double Hung Tilt':  116, 'Casement':  130, 'Awning':  130, 'End-Vent':  116, 'Single Slider Tilt':  114, 'Single Hung Tilt':  114, 'Tilt and Turn':  258, 'Fixed Tilt&Turn':  232, 'Turn Only':  208},
     ] 
    },
    {
      id: 'w1',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.square1`,       // e.g. 7.2
        columnExpr: `doorData.frameData.type1`    // e.g. "FixedCasement"
      },
      "surcharge1": {
        "condition": "result > 0",
        "add": {
          "id": "ref_ShapePrice",
          "key1": "doorData.frameData.shape1",
          "key2": "doorData.frameData.type1"
        }
      }
    },
    
    {
       id: 'w2',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label  !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.square2`,       // e.g. 7.2
        columnExpr: `doorData.frameData.type2`    // e.g. "FixedCasement"

      }
    },
    {
      id: 'w3',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label  !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.square3`,       // e.g. 7.2
        columnExpr: `doorData.frameData.type3`    // e.g. "FixedCasement"

      }
    },
    {
      id: 'w4',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label  !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.square4`,       // e.g. 7.2
        columnExpr: `doorData.frameData.type4`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'w5',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.square5`,       // e.g. 7.2
        columnExpr: `doorData.frameData.type5`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top1_1', // 1 Section
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr_old: `doorData.frameData.topsquare1`,       // e.g. 7.2
        valueExpr:  `doorData.frameData.totalTopSquare`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop1`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top1',
      table: {
        id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',               
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.topsquare1`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop1`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top2',
      table: {
         id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',               
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.topsquare2`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop2`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top3',
      table: {
         id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.topsquare3`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop3`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top4',
      table: {
       id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.topsquare4`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop4`    // e.g. "FixedCasement"
      }
    },
    {
      id: 'top5',
      table: {
       id1: 'ref_rangeWindowPricesWhite',
        id2: 'ref_rangeWindowPricesColor',
        id3: 'ref_rangeWindowPricesDoubleColor',
        id4: 'ref_rangeWindowPrices',
        id5: 'ref_rangeWindowPrices2',
                
        condition1: `doorData.finish.interiorColor.label  === 'White' && doorData.finish.exteriorColor.label === 'White'`,          //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on. 
        condition2: `(doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White') || 
                     (doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White')`,
        condition3: `doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'`,
        condition4: `true`,
        condition5: `true`, //if condition1 === true then ref_rangeWindowPrices, otherwise checking condition2 and so on.
        valueExpr: `doorData.frameData.topsquare5`,       // e.g. 7.2
        columnExpr: `doorData.frameData.typeTop4`    // e.g. "FixedCasement"
      }
    },
    { id: "ref_Textured", Frosted: 30,
      'Sandblast': 30,
      'Chinchilla': 30,
      'Gluechip': 30,
      'Rain blast': 30,
      'Pinhead': 30,
      'Acid Edged': 30 
    },
    {
      id: "TexturedDesign",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      price1: [`ref_Textured`, "doorData.glass.texturedDesign1.value"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_Tinted", Grey: 20, 'Bronze': 20 },
    {
      id: "TintedDesign",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      price1: [`ref_Tinted`, "doorData.glass.tintedDesign1.value"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_GlazingType", 'Double': 50, 'Triple': 70 },
    {
      id: "GlazingType",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      price1: [`ref_GlazingType`, "doorData.glass.glazingType1"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_GlassEnergy", 
      "3mm":{
        'LowE 8071':0,
        'LowE 272':0,
        'LowE 180':0,
        'LowE 366':3.2,
        'LowE i89':12,
        'CG 70 (RLE)':0,
        'SNX 62/27':0,
        'LowE 180 and i89':8,
        'LowE 272 and i89':8,
        'LowE 366 and i89':8,
        'Neat LowE 180':12,
        'Neat LowE 272':12,
        'Neat LowE 366':12 
      },
      "4mm":{
        'LowE 8071':0,
        'LowE 272':0,
        'LowE 180':0,
        'LowE 366':3.2,
        'LowE i89':12,
        'CG 70 (RLE)':0,
        'SNX 62/27':0,
        'LowE 180 and i89':8,
        'LowE 272 and i89':8,
        'LowE 366 and i89':8,
        'Neat LowE 180':12,
        'Neat LowE 272':12,
        'Neat LowE 366':12 
      },
      "5mm":{
        'LowE 8071':0,
        'LowE 272':0,
        'LowE 180':0,
        'LowE 366':3.2,
        'LowE i89':12,
        'CG 70 (RLE)':0,
        'SNX 62/27':0,
        'LowE 180 and i89':8,
        'LowE 272 and i89':8,
        'LowE 366 and i89':8,
        'Neat LowE 180':12,
        'Neat LowE 272':12,
        'Neat LowE 366':12 
      },
      "6mm":{
        'LowE 8071':0,
        'LowE 272':0,
        'LowE 180':0,
        'LowE 366':3.2,
        'LowE i89':12,
        'CG 70 (RLE)':0,
        'SNX 62/27':0,
        'LowE 180 and i89':8,
        'LowE 272 and i89':8,
        'LowE 366 and i89':8,
        'Neat LowE 180':12,
        'Neat LowE 272':12,
        'Neat LowE 366':12 
      },
    },
    {
      id: "GlassEnergy",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      //price1: [`ref_GlassEnergy`, "doorData.glass.glassEnergy1"],
      price1: { 
        id: "ref_GlassEnergy", 
        key1: "doorData.glass.glassThickness1", 
        key2: "doorData.glass.glassEnergy1.value" 
      },
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_NeatGlass", Yes: 8, No: 0 },
    {
      id: "NeatGlass",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      price1: [`ref_NeatGlass`, "doorData.glass.neatGlass1"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_GlassStrength",
      'Annealed':0,
      'Laminated Both Sides': 105,
      'Laminated External': 52.5,
      'Laminated Internal': 52.5,
      'Timbered Both Sides': 88,
      'Tempered External': 44,
      'Tempered Internal': 44
    },
    {
      id: "GlassStrength",
      formula: "doorData.frameData.totalSquare* <<price1>>",
      price1: [`ref_GlassStrength`, "doorData.glass.glassStrength1.value"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_brickmoldSize", 
          '11/16"': 5.6,
          '1"': 5.6,
          '1" w/Nailing Fin': 6.5,
          '1.25"': 5.6,
          '1.25" w/Nailing Fin': 6.5,
          '1.5"': 5.6,
          '1.5" w/Nailing Fin': 6.5,
          '2"': 7.0,
          '2" w/Nailing Fin': 7.0,
          '3.5"': 9.0,
          '3.5" w/Nailing Fin': 10.0, 
          'Stucco Flange': 5.0
    },
    {
      id: "brickmoldSize",
      formula: "2*((doorData?.frameData?.mainRowWidth_d + doorData?.frameData?.mainRowHeight_d)/12)*<<price1>>",
      price1: [`ref_brickmoldSize`, "doorData.installation.brickmoldSize.value"],
      unitPrice: 1,
      minValue: 0
    },
    { id: "ref_jambType", 
          'None': 0.0,
          '1/4" Round': 2.0,
          'Jamb Return Only': 2.0,
          'Vinyl Jamb Ext': 15.0,
          'Cove Moulding': 2.0,
          'Door Stop': 2.0,
          'Paint Grade Ext': 10.30
    },
    {
      "id": "jambType",
      "formula": "2*(Number(doorData?.frameData?.mainRowWidth_d || 0) + Number(doorData?.frameData?.mainRowHeight_d || 0) + Number(doorData.frameData.uHeight_d_real || 0)) * <<price1>> / 12",
      "unitPrice": 1,
      "minValue": 0,
      "price1": [
        "ref_jambType",
        "doorData.installation.jambType.value"
      ]
    },
    {
      id: "jambTypeOld",
      formula: "doorData?.frameData?.mainRowWidth_d*<<price1>>",
      price1: [`ref_jambType`, "doorData.installation.jambType"],
      unitPrice: 1,
      minValue: 0
    },

    { id: "ref_interiorCasing", 
      'None': 0.0,
      'Wood Colonial': 10.30,
      'Wood Flat': 10.30,
      'Stud Beveled': 10.30,
      'Wood Backbend': 14.00,
      'Vinyl': 15.00
    },
    {
      id: "interiorCasing",
      formula: "2*(Number(doorData?.frameData?.mainRowWidth_d || 0) + Number(doorData?.frameData?.mainRowHeight_d || 0) + Number(doorData.frameData.uHeight_d_real || 0))*<<price1>> / 12",
      price1: [`ref_interiorCasing`, "doorData.installation.interiorCasing.value"],
      unitPrice: 1,
      minValue: 0
    },
    {
      "id": "top1_grillType",
      "formula": "(Number(doorData.grills.glassDividersHorizontalTop1 || 0) + 1) * (Number(doorData.grills.glassDividersVerticalTop1 || 0) + 1)",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.grillsPatternTop1.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      "id": "top2_grillType",
      "formula": "(Number(doorData.grills.glassDividersHorizontalTop2 || 0) + 1) * (Number(doorData.grills.glassDividersVerticalTop2 || 0) + 1)",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.grillsPatternTop2.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      "id": "top3_grillType",
      "formula": "(Number(doorData.grills.glassDividersHorizontalTop3 || 0) + 1) * (Number(doorData.grills.glassDividersVerticalTop3 || 0) + 1)",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.grillsPatternTop3.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      "id": "top4_grillType",
      "formula": "(Number(Number(doorData.grills.glassDividersHorizontalTop4 || 0) || 0) + 1) * (Number(Number(doorData.grills.glassDividersVerticalTop4 || 0) || 0) + 1)",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.grillsPatternTop4.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      "id": "top5_grillType",
      "formula": "(Number(Number(doorData.grills.glassDividersHorizontalTop5 || 0) || 0) + 1) * (Number(Number(doorData.grills.glassDividersVerticalTop5 || 0) || 0) + 1)",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.grillsPatternTop5.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      "id": "topArch",
      "active": true,
      "table": {
        "valueExpr": "doorData.frameData.totalTopSquare",
        "columnExpr": "doorData.frameData.typeTop1",
        "id1": "ref_rangeWindowPricesWhite",
        "condition1": "doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label === 'White'",
        "id2": "ref_rangeWindowPricesColor",
        "condition2": "doorData.finish.interiorColor.label === 'White' && doorData.finish.exteriorColor.label !== 'White'",
        "id3": "ref_rangeWindowPricesColor",
        "condition3": "doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label === 'White'",
        "id4": "ref_rangeWindowPricesDoubleColor",
        "condition4": "doorData.finish.interiorColor.label !== 'White' && doorData.finish.exteriorColor.label !== 'White'"
      },
      "surcharge": {
        "condition": "result > 0",
        "add": {
          "id": "ref_ShapePrice",
          "key1": "doorData.frameData.archShape",
          "key2": "doorData.frameData.archType"
        }
      }
    },
    {
      "id": "archGrillType",
      "formula": "(Number(doorData.grills.archHorizontalGrills || 0) || Number(doorData.grills.archVerticalGrills || 0)) ? (Number(Number(doorData.grills.archHorizontalGrills || 0) || 0) + 1) * (Number(Number(doorData.grills.archVerticalGrills || 0) || 0) + 1) : 0",
      "unitPrice": 1,
      "minValue": 0,
      "condition": "doorData.grills.archGrillPattern.value === 'Colonial'",
      "multiplicator": {
        "condition1": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value1": 3.5,
        "condition2": "doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value2": 4.5,
        "condition3": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White'",
        "value3": 4.5,
        "condition4": "doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label !== 'White'",
        "value4": 5
      }
    },
    {
      id: "w1_grillType",
      formula: "(Number(doorData.grills.glassDividersHorizontal1 || 0) + 1) * (Number(doorData.grills.glassDividersVertical1 || 0) + 1)",
      condition: `doorData.grills.grillsPattern1.value === 'Colonial'`,
      unitPrice: 3.5,
      minValue: 0,
      multiplicator: {
        condition1: `doorData.grills.interiorFinish.label  === 'White' && doorData.grills.exteriorFinish.label === 'White'`,  
        value1: 1,      
        condition2: `(doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White') || 
                     (doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White')`,
        value2: 4.5/3.5,
        condition3: `doorData.grills.interiorFinish.label  !== 'White' && doorData.grills.exteriorFinish.label !== 'White'`,
        value3: 5.0/3.5
      }
    },
   {
      id: "w2_grillType",
      formula: "(Number(doorData.grills.glassDividersHorizontal2 || 0) + 1) * (Number(doorData.grills.glassDividersVertical2 || 0) + 1)",
      condition: `doorData.grills.grillsPattern2.value === 'Colonial'`,
      unitPrice: 3.5,
      minValue: 0,
      multiplicator: {
        condition1: `doorData.grills.interiorFinish.label  === 'White' && doorData.grills.exteriorFinish.label === 'White'`,  
        value1: 1,      
        condition2: `(doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White') || 
                     (doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White')`,
        value2: 4.5/3.5,
        condition3: `doorData.grills.interiorFinish.label  !== 'White' && doorData.grills.exteriorFinish.label !== 'White'`,
        value3: 5.0/3.5
      }
    },
   {
      id: "w3_grillType",
      formula: "(Number(doorData.grills.glassDividersHorizontal3 || 0) + 1) * (Number(doorData.grills.glassDividersVertical3 || 0) + 1)",
      condition: `doorData.grills.grillsPattern3.value === 'Colonial'`,
      unitPrice: 3.5,
      minValue: 0,
      multiplicator: {
        condition1: `doorData.grills.interiorFinish.label  === 'White' && doorData.grills.exteriorFinish.label === 'White'`,  
        value1: 1,      
        condition2: `(doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White') || 
                     (doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White')`,
        value2: 4.5/3.5,
        condition3: `doorData.grills.interiorFinish.label  !== 'White' && doorData.grills.exteriorFinish.label !== 'White'`,
        value3: 5.0/3.5
      }
    },
   {
      id: "w4_grillType",
      formula: "(Number(doorData.grills.glassDividersHorizontal4 || 0) + 1) * (Number(doorData.grills.glassDividersVertical4 || 0) + 1)",
      condition: `doorData.grills.grillsPattern4.value === 'Colonial'`,
      unitPrice: 3.5,
      minValue: 0,
      multiplicator: {
        condition1: `doorData.grills.interiorFinish.label  === 'White' && doorData.grills.exteriorFinish.label === 'White'`,  
        value1: 1,      
        condition2: `(doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White') || 
                     (doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White')`,
        value2: 4.5/3.5,
        condition3: `doorData.grills.interiorFinish.label  !== 'White' && doorData.grills.exteriorFinish.label !== 'White'`,
        value3: 5.0/3.5
      }
    },
   {
      id: "w5_grillType",
      formula: "(Number(doorData.grills.glassDividersHorizontal5 || 0) + 1) * (Number(doorData.grills.glassDividersVertical5 || 0) + 1)",
      condition: `doorData.grills.grillsPattern5.value === 'Colonial'`,
      unitPrice: 3.5,
      minValue: 0,
      multiplicator: {
        condition1: `doorData.grills.interiorFinish.label  === 'White' && doorData.grills.exteriorFinish.label === 'White'`,  
        value1: 1,      
        condition2: `(doorData.grills.interiorFinish.label === 'White' && doorData.grills.exteriorFinish.label !== 'White') || 
                     (doorData.grills.interiorFinish.label !== 'White' && doorData.grills.exteriorFinish.label === 'White')`,
        value2: 4.5/3.5,
        condition3: `doorData.grills.interiorFinish.label  !== 'White' && doorData.grills.exteriorFinish.label !== 'White'`,
        value3: 5.0/3.5
      }
    },
    {
      "id": "ref_ShapePrice",
      "Rectangle": {
        "Picture": 0,
        "Fixed Casement": 0,
        "Double Slider Tilt": 0,
        "Double Hung Tilt": 0,
        "Top Arch": 350
      },
      "Triangle": {
        "Picture": 250,
        "Fixed Casement": 250,
        "Double Slider Tilt": 250,
        "Double Hung Tilt": 250
      },
      "Trapezoid": {
        "Picture": 250,
        "Fixed Casement": 250,
        "Double Slider Tilt": 250,
        "Double Hung Tilt": 250
      },
      "AngledTopTrapezoid": {
        "Picture": 250,
        "Fixed Casement": 250,
        "Double Slider Tilt": 250,
        "Double Hung Tilt": 250
      },
      "Pentagon": {
        "Picture": 200,
        "Fixed Casement": 200,
        "Double Slider Tilt": 200,
        "Double Hung Tilt": 200
      },
      "Octagon": {
        "Picture": 200,
        "Fixed Casement": 200,
        "Double Slider Tilt": 200,
        "Double Hung Tilt": 200
      },
      "HalfEyebrow": {
        "Picture": 300,
        "Fixed Casement": 300,
        "Double Slider Tilt": 300,
        "Double Hung Tilt": 300
      },
      "Eyebrow": {
        "Picture": 300,
        "Fixed Casement": 300,
        "Double Slider Tilt": 300,
        "Double Hung Tilt": 300
      }
    },

  ];
  
  export default priceRules;
  